import { useTranslation } from 'react-i18next';

import iconCheckCircle from '@/assets/images/iconCheckCircle.svg';
import ModaleDefaut from '@/components/ModaleDefaut/ModaleDefaut';

import styles from '@/modals/ContentModalRenonciation/styles.module.css';

interface ModalRenonciationSuccessProps {
  isRetractation: boolean;
  onSuccess: () => void;
  onClose: () => void;
}

const ModalRenonciationSuccess = ({ isRetractation, onSuccess, onClose }: ModalRenonciationSuccessProps) => {
  const { t } = useTranslation();

  return (
    <ModaleDefaut
      title={
        isRetractation
          ? t('modals.cancelableModal.retractation.requestSentText')
          : t('modals.cancelableModal.requestSentText')
      }
      content={
        <div className={styles.successContent}>
          <div className={styles.successIconContainer}>
            <img src={iconCheckCircle} alt="Succès" className={styles.successIcon} />
          </div>
          <p className={styles.successText}>
            {isRetractation ? t('modals.cancelableModal.retractation.text4') : t('modals.cancelableModal.text4')}
          </p>
        </div>
      }
      btnLabel={t('modals.cancelableModal.backButton')}
      btnVariant="primary"
      btnSize="large"
      onClickBtn={onSuccess}
      onClickClose={onClose}
      size="large"
      mobileStyle="stick-to-bottom"
    />
  );
};

export default ModalRenonciationSuccess;
